import { createAction, createReducer } from '@reduxjs/toolkit'

const initialState = {
  searchEnabled: true
}

export const setSearchEnabled = createAction('SET_SEARCH_ENABLED')

export default createReducer(initialState, (builder) => {
  builder.addCase(setSearchEnabled, (state, action) => {
    state.searchEnabled = action.payload
  })
})
